import React from 'react';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';

interface CompareFooterProps {
  onClose: () => void;
}

const CompareFooter = ({ onClose }: CompareFooterProps) => (
  <footer
    className={cn(
      'tw-flex tw-items-center tw-justify-end tw-px-6 tw-py-3',
      'tw-border-t tw-border-solid tw-border-med-grey tw-shrink-0',
    )}
  >
    <button
      className={cn(
        'tw-text-sm tw-text-tci-purple tw-bg-transparent tw-border-0',
        'tw-cursor-pointer hover:tw-underline',
      )}
      type="button"
      onClick={onClose}
    >
      {I18n.t('close')}
    </button>
  </footer>
);

export default CompareFooter;
